import { Component, EventEmitter, Input, Output, ViewChild, type OnInit } from "@angular/core";
import { ProfileProvider } from "../../../../../../../shared/cw-backend/providers/security/profile/profile.provider";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SnackBarService } from "cw-utils";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { DomSanitizer } from "@angular/platform-browser";
import { MatMenuTrigger } from "@angular/material/menu";

@Component({
    selector: "cw-profile-signature",
    templateUrl: "./profile-signature.component.html",
    styleUrls: ["./profile-signature.component.scss"],
})
export class ProfileSignatureComponent implements OnInit {
    @Input("iProfile") iProfile: any;
    @Input("iEartefactId") iEartefactId: any;
    @Output("oRemoveSignature")oRemoveSignature = new EventEmitter<any>();
    @Output("oInsertSignature")oInsertSignature = new EventEmitter<any>();
    @ViewChild("imageDrop") imageDrop: any;
    @ViewChild("imageInput") imageInput: any;
    @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;

    // img variables
    selectedFiles!: FileList;
    currentFile!: File | undefined;
    imageBase64!: string;
    imagePath: any;
    imageMain: any;
    pendingImage: boolean = false;
    acceptedImageTypes: any = { "image/png": true, "image/jpeg": true };
    imageUpload!: FormGroup;

    eartefact: any;

    constructor(
        private profileProvider: ProfileProvider,
        private _formBuilder: FormBuilder,
        private snackBar: SnackBarService,
        private progressBar: FuseProgressBarService,
        private _sanitizer: DomSanitizer,
    ) {}

    ngOnInit() {
        this.getSignature();
    }

    getSignature() {
        if (this.iEartefactId == null) {
            return;
        }
        this.profileProvider
            .getEartefactbyId(this.iEartefactId)
            .then((res) => {
                this.eartefact = res.body.data;
            })
            .catch((err) => {});
    }

    uploadSignature() {
        if (!this.currentFile) {
            this.snackBar.warnMessage("Selecione um arquivo válido.");
            return;
        }
        this.profileProvider
            .uploadSgnature(this.currentFile, this.iProfile)
            .then((res) => {
                console.log(res);
                this.snackBar.successMessage("Importado com sucesso.");
                this.iEartefactId = res.data;
                this.oInsertSignature.emit(this.iEartefactId);
            })
            .catch((err) => {
                console.error("🚀 ~~ err:", err);
            });
    }

    deleteSignature() {
        this.profileProvider
            .deleteSignature(this.iProfile, this.iEartefactId)
            .then((res) => {
                this.snackBar.successMessage("Excluido com sucesso.");
                this.iEartefactId = null;
                this.oRemoveSignature.emit(true);
            })
            .catch((err) => {
                console.error("🚀 ~~ err:", err);
            });
    }

    imageChange(event: any) {
        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) {
            this.currentFile = undefined;
            return;
        }

        const file = input.files[0];
        if (
            file.name.toLowerCase().endsWith(".png") ||
            file.name.toLowerCase().endsWith(".jpg") ||
            file.name.toLowerCase().endsWith(".jpeg")
        ) {
            this.currentFile = file;
        } else {
            this.snackBar.warnMessage("Selecione um arquivo OFX válido.");
            this.currentFile = undefined;
            input.value = "";
            return;
        }
    }
}
